export const MAIL_VIEWS = {
    CURRENT: 'CURRENT',
    ARCHIVED: 'ARCHIVED',
}